(() => {
  const rootSelector = '[data-diyprint-products-v2]';

  function initCarousel(carousel) {
    if (carousel.dataset.diyCarouselReady) return;
    const track = carousel.querySelector('[data-diy-carousel-track]');
    const dots = carousel.querySelector('[data-diy-carousel-dots]');
    const previous = carousel.querySelector('[data-diy-carousel-prev]');
    const next = carousel.querySelector('[data-diy-carousel-next]');
    if (!track || !dots || !track.children.length) return;
    carousel.dataset.diyCarouselReady = 'true';

    const cardWidth = () => {
      const first = track.children[0];
      if (!first) return 1;
      const style = getComputedStyle(track);
      const gap = Number.parseFloat(style.columnGap || style.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    };
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const pageStep = () => {
      const first = track.children[0];
      if (!first) return 1;
      return Math.max(cardWidth(), cardWidth() * Math.max(1, Math.floor((track.clientWidth + (Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0)) / cardWidth())));
    };
    const pages = () => Math.max(1, Math.ceil(maxScroll() / pageStep()) + 1);
    const pageOffset = (index) => Math.min(index * pageStep(), maxScroll());
    const renderDots = () => {
      const count = maxScroll() > 1 ? pages() : 0;
      carousel.classList.toggle('is-static', count === 0);
      if (dots.children.length === count) return;
      dots.innerHTML = '';
      for (let index = 0; index < count; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'diyprint-products-v2__dot';
        dot.setAttribute('aria-label', 'Go to page ' + (index + 1));
        dot.addEventListener('click', () => track.scrollTo({ left: pageOffset(index), behavior: 'smooth' }));
        dots.append(dot);
      }
    };
    const updateDots = () => {
      const current = Math.min(Math.max(0, dots.children.length - 1), Math.round(track.scrollLeft / pageStep()));
      [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
    };
    previous?.addEventListener('click', () => track.scrollBy({ left: -pageStep(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: pageStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(updateDots), { passive: true });
    new ResizeObserver(() => { renderDots(); updateDots(); }).observe(track);
    renderDots();
    updateDots();
  }

  function init(root = document) {
    root.querySelectorAll(rootSelector + ' [data-diy-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

